<div class="page--padder"></div>
<article class="page-intro">
  <div class="container">
    <div class="text-align-virt">
      <H1>Current News</H1>
    </div>
  </div>
</article>
<section>
  @if (editMode()) {
    <div class="btn-edit">
      <button class="button" (click)="onAddItem()">Add Post</button>
    </div>
  }
  @for (article of articles; track article.id) {
    <app-blog-list-item [article]="article" (deleted)="onDeleted($event)"></app-blog-list-item>
  }
</section>
